<template>
  <QuestionBase :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">

    <InputRadioMultiple
        v-model="data"
        :options="conveyanceActionOptions"
        :db="db"
        :args="args"
        :skipped="skipped"
        class="radio-options-wide"
        :errors-post="errorsPost"
        :js-errors="jsErrors"
        :no-save="noSave"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />

    <!-- <InputRadio v-model="data"
                :args="args"
                :class="'radio-options-wide'"
                :db="db"
                :errors-post="errorsPost"
                :js-errors="jsErrors"
                :no-save="noSave"
                :options="conveyanceActionOptions"
                :skipped="skipped"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" /> -->
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {conveyanceOptions} from "../../../options/conveyanceOptions";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadioMultiple from "@/components/common/questionnaires/question/inputs/InputRadioMutiple";

export default {
  name: 'Actions',
  mixins: [
    questionLoadHelpers,
    conveyanceOptions
  ],
  components: {
    InputRadioMultiple,
    QuestionBase
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    noSave: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'What are you looking to achieve?',
        subTitle: 'If you are buying and selling a property at the same time, select both options.',
        tip: null
      },
      db: {
        saveLocation: `conveyance_quote?code=${this.$route.params.code}`,
        saveField: 'actions',
      },
      args: {
        taggable: true,
        label: null,
        placeholder: 'Please select..',
        skippable: false,
        required: true,
        inputClass: 'field-75'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>